"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromCognitoIdentityPool = void 0;
const credential_provider_cognito_identity_1 = require("@aws-sdk/credential-provider-cognito-identity");
const fromCognitoIdentityPool = (options) => (0, credential_provider_cognito_identity_1.fromCognitoIdentityPool)({
    ...options,
});
exports.fromCognitoIdentityPool = fromCognitoIdentityPool;
